// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__3lIfA","upload":"Small_upload__2kbvU","imageWrap":"Small_imageWrap__vWhsK","removeBtn":"Small_removeBtn__UrK7e"};